export default {
  setCategories: (state, payload) => { state.categories = payload },
  setCategory: (state, payload) => { state.category = payload },
}